import { z } from "zod";

const guidSchema = z.string().uuid();
const nullableTextSchema = z.string().nullable().optional();
const nullableGuidSchema = guidSchema.nullable().optional();
const nullableDateSchema = z.string().datetime({ offset: true }).nullable().optional();

export const capaRecordSchema = z.object({
  id: guidSchema,
  complaintId: guidSchema,
  capaCode: z.string().min(1),
  actionTypeId: guidSchema,
  actionTypeCode: z.string().min(1),
  actionTypeName: z.string().min(1),
  actionDescription: z.string().min(1),
  ownerUserId: guidSchema,
  ownerName: z.string().min(1),
  dueDate: z.string().datetime({ offset: true }),
  statusId: guidSchema,
  statusCode: z.string().min(1),
  statusName: z.string().min(1),
  effectivenessRequired: z.boolean(),
  effectivenessCheckDate: nullableDateSchema,
  effectivenessStatusId: nullableGuidSchema,
  effectivenessStatusCode: nullableTextSchema,
  effectivenessStatusName: nullableTextSchema,
  closedAt: nullableDateSchema,
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: nullableDateSchema,
  rowVersion: nullableTextSchema,
}).strict();

export type CapaRecordDto = z.infer<typeof capaRecordSchema>;
export type CapaDto = CapaRecordDto;
export type CapaMutationResponse = CapaRecordDto;

export type CapaCreateRequest = Readonly<{
  complaintId: string;
  actionTypeId: string;
  actionDescription: string;
  ownerUserId: string;
  dueDate: string;
  statusId: string;
  effectivenessRequired: boolean;
  effectivenessCheckDate?: string | undefined;
}>;

export type CapaUpdateRequest = Readonly<{
  actionDescription?: string | undefined;
  actionTypeId?: string | undefined;
  ownerUserId?: string | undefined;
  dueDate?: string | undefined;
  effectivenessRequired?: boolean | undefined;
  effectivenessCheckDate?: string | undefined;
  rowVersion?: string | undefined;
}>;

export type CapaActionRequest = Readonly<{
  remarks?: string | undefined;
  reason?: string | undefined;
  assignedToUserId?: string | undefined;
  closedStatusId?: string | undefined;
  effectivenessStatusId?: string | undefined;
  closureComment?: string | undefined;
  rowVersion?: string | undefined;
}>;

export function parseCapaRecord(input: unknown): CapaRecordDto {
  return capaRecordSchema.parse(input);
}

export function parseCapaRecordList(input: unknown): readonly CapaRecordDto[] {
  return z.array(capaRecordSchema).parse(input);
}
